import { Link } from "react-router-dom";
import { useLocale } from "@/contexts/LanguageContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileCTABar } from "@/components/layout/MobileCTABar";
import { ArrowLeft, Phone } from "lucide-react";

const NotFound = () => {
  const { locale } = useLocale();
  const isEs = locale === "es";

  return (
    <>
      <Header />
      <main id="main-content" className="min-h-[60vh] flex items-center justify-center py-20">
        <div className="container mx-auto max-w-2xl px-4 text-center">
          <p className="text-8xl font-serif font-bold text-primary mb-4">404</p>
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
            {isEs ? "Página no encontrada" : "Page Not Found"}
          </h1>
          <p className="text-lg text-muted-foreground mb-8">
            {isEs
              ? "Lo sentimos, la página que busca no existe o ha sido movida."
              : "Sorry, the page you're looking for doesn't exist or has been moved."}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Link
              to={isEs ? "/es" : "/"}
              className="inline-flex items-center gap-2 bg-ivory-cta text-ivory-cta-foreground px-6 py-3 rounded-md font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              {isEs ? "Ir al Inicio" : "Go Home"}
            </Link>
            <a
              href="tel:+13125550100"
              className="inline-flex items-center gap-2 border border-primary text-primary px-6 py-3 rounded-md font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <Phone className="h-4 w-4" />
              {isEs ? "Llamar Ahora" : "Call Us"}
            </a>
          </div>
        </div>
      </main>
      <Footer />
      <MobileCTABar />
    </>
  );
};

export default NotFound;
